import React, { Component } from 'react';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../../state/fetch-dux';
import TagForm from './TagForm';
import { Button } from 'react-bootstrap';

const TagTable = ({ tag, onEdit, onDelete }) => (
  <div>
    <div className="form">
      <table className="table">
        <tbody>
          <tr>
            <th>Tag</th>
            <td>{tag.value}</td>
          </tr>
          <tr>
            <th>Color</th>
            <td><span className="color" style={{backgroundColor: tag.color}} /> {tag.color}</td>
          </tr>
          <tr>
            <th>Date Created</th>
            <td>{moment(tag.dateCreated).format('M/DD/YYYY hh:mm a')}</td>
          </tr>
          <tr>
            <th>Last Updated</th>
            <td>{moment(tag.lastUpdated || tag.dateCreated).format('M/DD/YYYY hh:mm a')}</td>
          </tr>
          <tr>
            <th>Associated Assets</th>
            <td>{tag.assetCount}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div className="text-right">
      <Button bsStyle="hollow-info" onClick={onEdit}>
        <span className="ti ti-pencil" /> Edit
      </Button>
      {' '}
      <Button bsStyle="hollow-primary" onClick={onDelete}>
        <span className="ti ti-trash" /> Delete
      </Button>
    </div>
  </div>
)

class TagDetail extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAddSubmit = this.handleAddSubmit.bind(this);
  }
  componentDidUpdate(prevProps) {
    if ((prevProps.tag || {})._id === (this.props.tag || {})._id) return;
    this.props.setIsEditing(false)
  }
  handleSubmit(payload) {
    const { putTag, tag, getAllTags, setIsEditing } = this.props;
    putTag({ payload, id: tag._id }, 'tags-form', null, () => {
      setIsEditing(false)
      getAllTags()
    });
  }
  handleAddSubmit(payload) {
    const { postTag, tag, getAllTags, setIsEditing, setIsAdding } = this.props;
    postTag(payload, 'tags-form', null, () => {
      setIsAdding(false)
      setIsEditing(false)
      getAllTags()
    });
  }
  render () {
    const { tag, editing, adding, setIsEditing, setIsAdding, onDeleteTag } = this.props;

    const handleCancelAdd = () => {
      setIsAdding(false)
    }

    if (adding) return (
      <TagForm
        cancelEdit={handleCancelAdd}
        onSubmit={this.handleAddSubmit}
      />
    );

    if (!tag) return false;
    const handleEditTag = () => {
      setIsEditing(true)
    }
    const handleCancelEdit = () => {
      setIsEditing(false)
    }

    if (editing) return (
      <TagForm
        cancelEdit={handleCancelEdit}
        onSubmit={this.handleSubmit}
        initialValues={{ value: tag.value, color: tag.color }}
      />
    );



    return <TagTable tag={tag} onEdit={handleEditTag} onDelete={onDeleteTag} />
  }
}

const mapState = state => {
  const {
    error: tagsErr
  } = state.putTag.toJS();

  const error = tagsErr;

  return {
    error,
  };
};
const mapDispatch = dispatch => bindActionCreators({
  getAllTags: fetchDux.getAllTags.createAction,
  putTag: fetchDux.putTag.createAction,
  clearPutTag: fetchDux.putTag.clearAction,
  postTag: fetchDux.postTag.createAction,
  clearPostTag: fetchDux.postTag.clearAction,
}, dispatch);

export default connect(mapState, mapDispatch)(TagDetail);



// WEBPACK FOOTER //
// ./src/components/routes/tags/TagDetail.js